import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Overview } from './pages/Overview';
import { BoardPillars } from './pages/BoardPillars';
import { Impact } from './pages/Impact';
import { BoardServicePage } from './pages/BoardServicePage';
import { Speaking } from './pages/Speaking';
import { Recognition } from './pages/Recognition';
import { Career } from './pages/Career';
import { PersonalLife } from './pages/PersonalLife';
import { Inquire } from './pages/Inquire';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjzp7bw1w1pq">
      <Routes data-id="element-1" data-mp="31b8j3x6zk98o">
        <Route element={<Layout data-id="element-3" data-mp="31bi9hlvy0iew" />} data-id="element-2" data-mp="31ayv2f5i4c5m">
          <Route path="/" element={<Overview data-id="element-5" data-mp="2wk08wyxu0jug" />} data-id="element-4" data-mp="31c1iue7j1yhb" />
          <Route path="/pillars" element={<BoardPillars data-id="element-7" data-mp="2wiff5bjcd4xn" />} data-id="element-6" data-mp="2wjgu3r3habkn" />
          <Route path="/impact" element={<Impact data-id="element-9" data-mp="28tw5arkn8k3g" />} data-id="element-8" data-mp="2wi5nzkmk8rqd" />
          <Route path="/board-service" element={<BoardServicePage data-id="element-11" data-mp="28sbar1ybx15l" />} data-id="element-10" data-mp="28te4dhn1dhp7" />
          <Route path="/speaking" element={<Speaking data-id="element-13" data-mp="23ujmchww7x65" />} data-id="element-12" data-mp="23vuokdaowwv5" />
          <Route path="/recognition" element={<Recognition data-id="element-15" data-mp="3ik7e6ay3c1o0" />} data-id="element-14" data-mp="23t8hsfvmildz" />
          <Route path="/career" element={<Career data-id="element-17" data-mp="3ijpet5g4t7bv" />} data-id="element-16" data-mp="3iiwg8rrbto4t" />
          <Route path="/personal" element={<PersonalLife data-id="element-19" data-mp="3mkrchhuehbbq" />} data-id="element-18" data-mp="3mljaezbgzl56" />
          <Route path="/inquire" element={<Inquire data-id="element-21" data-mp="3mj6lu3b7icj5" />} data-id="element-20" data-mp="3mjztd6hzp62c" />
          <Route path="*" element={<Overview data-id="element-23" data-mp="3rdki07xp0nov" />} data-id="element-22" data-mp="3rbrbcsn2y3gv" />
        </Route>
      </Routes>
    </BrowserRouter>;
}